import { render, staticRenderFns } from "./ValliList.vue?vue&type=template&id=0e850a92&scoped=true"
import script from "./ValliList.vue?vue&type=script&lang=js"
export * from "./ValliList.vue?vue&type=script&lang=js"
import style0 from "./ValliList.vue?vue&type=style&index=0&id=0e850a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e850a92",
  null
  
)

export default component.exports